import { useEffect, useState } from 'react';
import { LICENSE_INPUT_TYPES } from 'constants/license';

const gradeOptions = [
  {
    label: 'Grade 1',
    value: 0,
  },
  {
    label: 'Grade 2',
    value: 1,
  },
];
const regionOptions = [
  {
    label: 'Region 1',
    value: 0,
  },
  {
    label: 'Region 2',
    value: 1,
  },
  {
    label: 'Region 1',
    value: 0,
  },
  {
    label: 'Region 2',
    value: 1,
  },
  {
    label: 'Region 1',
    value: 0,
  },
  {
    label: 'Region 2',
    value: 1,
  },
];

const useLogic = ({ geos, gradeGroups }) => {
  const [regions, setRegions] = useState();
  const [grades, setGrades] = useState();

  useEffect(() => {
    setGrades(gradeOptions?.filter(grade => gradeGroups?.includes(grade?.value)));
  }, [gradeOptions]);

  useEffect(() => {
    setRegions(regionOptions?.filter(grade => geos?.includes(grade?.value)));
  }, [regionOptions]);

  const handleChange = (key, value) => {
    if (key === LICENSE_INPUT_TYPES.REGIONS) {
      setRegions(value);
    } else {
      setGrades(value);
    }
  };

  const handleClose = () => {};
  const handleSave = () => {};

  return {
    regions,
    grades,
    handleChange,
    gradeOptions,
    regionOptions,
    handleClose,
    handleSave,
  };
};

export default useLogic;
